// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-general-js": () => import("/zeit/351d06eb/src/templates/general.js" /* webpackChunkName: "component---src-templates-general-js" */),
  "component---src-templates-team-js": () => import("/zeit/351d06eb/src/templates/team.js" /* webpackChunkName: "component---src-templates-team-js" */),
  "component---src-pages-404-js": () => import("/zeit/351d06eb/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/zeit/351d06eb/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-products-index-js": () => import("/zeit/351d06eb/src/pages/products/index.js" /* webpackChunkName: "component---src-pages-products-index-js" */),
  "component---src-pages-team-index-js": () => import("/zeit/351d06eb/src/pages/team/index.js" /* webpackChunkName: "component---src-pages-team-index-js" */)
}

